// extracted by mini-css-extract-plugin
export default {"footerList":"Footer_footerList__EGi3C","itemsList":"Footer_itemsList__imiSV","footerLinks":"Footer_footerLinks__bKEjv","brandLogo":"Footer_brandLogo__gDuZu"};